// 入口页
import { render } from 'utils'
// 初始系统清除缓存
if (window.location.href.includes('token')) {
  localStorage.clear()
  sessionStorage.clear()
}
render()
